import React, { useState, useEffect } from "react";
import axios from "axios";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import Approved from "../../../assets/images/approved.png";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const QnaLive = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState(0);
  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios.get(`/api/admin/qna_live`).then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader title="QnA Live Events" image={Approved} count={count} />
      {buffer ? (
        <LoaderPost />
      ) : (
        <>
          <AllModuleData
            data={event_data}
            urlLink={`/superstar-admin/qna/details`}
            qna={"true"}
          />
        </>
      )}
    </>
  );
};

export default QnaLive;
